import { createSlice } from '@reduxjs/toolkit';

const chatSlice = createSlice({
    name: 'chat',
    initialState: {
        messages: [],
        socketConnected: false,
        rooms: [],
        current_room: null,
        activeClients: []
    },
    reducers: {
        isSocketConnected: (state, action) => {
            state.socketConnected = action.payload
        },
        setMessages: (state, action) => {
            state.messages = action.payload
        },
        pushSingleMessage: (state, action) => {
            state.messages.push(action.payload)
        },
        setRooms: (state, action) => {
            state.rooms = action.payload
        },
        setCurrentRoomInRedux: (state, action) => {
            state.current_room = action.payload
        },
        pushActiveClient: (state, action) => {
            state.rooms = state.rooms.map((room) => {
                if (room.room_id === action.payload) {
                    return { ...room, is_client_active: true };
                } else {
                    return { ...room, is_client_active: room?.is_client_active };
                }
            });
        },
        removeInActiveClient: (state, action) => {
            state.rooms = state.rooms.map((room) => {
                if (room.room_id === action.payload) {
                    return { ...room, is_client_active: false };
                } else {
                    return { ...room, is_client_active: room?.is_client_active };
                }
            });
        },
    },
});

export const { setMessages, pushSingleMessage, isSocketConnected, setRooms, setCurrentRoomInRedux, pushActiveClient, removeInActiveClient } = chatSlice.actions;
export default chatSlice.reducer;